function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import classNamesMaker from "classnames";
import { Icon, ICON_SIZES } from "#library/components/Icon/Icon";
import { Pictogram, PICTOGRAM_SIZES } from "#library/components/Pictogram/Pictogram";
import { isTypeWithinList } from "#library/components/ElementMessage/misc/utils";
import { useTheme } from "#library/components/ElementMessage/ThemeManagement";
import { ELEMENT_MESSAGE_TYPES_WITH_SYMBOL, ELEMENT_MESSAGE_TYPES_WITH_ICON, ELEMENT_MESSAGE_TYPES_WITH_PICTO } from "#library/components/ElementMessage/misc/constants";
import tips from "#library/assets/pictograms/jds_pictogram_tips.svg";
import info from "#library/assets/icons/jds_bellFull.svg";
import note from "#library/assets/icons/jds_light.svg";
import success from "#library/assets/icons/jds_checkCircleFull.svg";
import warning from "#library/assets/icons/jds_warningFull.svg";
import error from "#library/assets/icons/jds_crossCircleFull.svg";
import styles from "#library/components/ElementMessage/elementMessage.module.css";
var symbols = {
  tips: tips,
  info: info,
  note: note,
  success: success,
  warning: warning,
  error: error
};
export var ElementMessageSymbol = function ElementMessageSymbol() {
  var _useTheme = useTheme(),
    type = _useTheme.type;
  if (!isTypeWithinList(ELEMENT_MESSAGE_TYPES_WITH_SYMBOL, type)) {
    return null;
  }
  var withIcon = isTypeWithinList(ELEMENT_MESSAGE_TYPES_WITH_ICON, type);
  var withPictogram = isTypeWithinList(ELEMENT_MESSAGE_TYPES_WITH_PICTO, type);
  var symbolClassNames = classNamesMaker(styles["jds-ElementMessage__symbol"], styles["jds-ElementMessage__symbol--".concat(type)], withPictogram && styles["jds-ElementMessage__symbol--isPictogram"]);
  var commonProps = {
    xlinkHref: "#".concat(symbols[type].id)
  };
  return /*#__PURE__*/React.createElement("div", {
    role: "img",
    "aria-label": type,
    className: symbolClassNames
  }, withIcon && /*#__PURE__*/React.createElement(Icon, _extends({}, commonProps, {
    size: ICON_SIZES.MEDIUM
  })), withPictogram && /*#__PURE__*/React.createElement(Pictogram, _extends({}, commonProps, {
    size: PICTOGRAM_SIZES.SMALL
  })));
};